var _defs, _path, _circle, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChromeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "15.5 15.5 224.5 224.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cy: 0,
    cx: 0.5,
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f06b59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#df2227"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    r: 0.76,
    cy: 0.3,
    cx: 0.65,
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#4cb749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#388b41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    r: 0.8,
    cy: 0.25,
    cx: 0.36,
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FCD209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f7c616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc821e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    r: 1,
    cy: 0,
    cx: 0.5,
    spreadMethod: "pad",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7FB3DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0F5B94"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    r: 1,
    cy: 0,
    cx: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F6F0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ddd"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198 148a70 70 0 0 0-140 0h20a50 50 0 0 1 100 0",
    fillOpacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 45,
    cx: 127.5,
    cy: 127.6,
    fill: "url(#a)",
    stroke: "url(#b)",
    strokeWidth: 9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228 78A112 112 0 0 0 35 65l45 78a50 50 0 0 1 47-65",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 65a112 112 0 0 0 84 174l47-80a50 50 0 0 1-86-16",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119 239A112 112 0 0 0 228 78H127a50 50 0 0 1 39 81",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m35 65 45 78a50 50 0 0 1 2-34L37 62",
    opacity: 0.075
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m119 239 47-80a50 50 0 0 1-29 17l-20 63M228 78H127a50 50 0 0 1 39 19l64-16",
    opacity: 0.05
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeLogo);
export default __webpack_public_path__ + "static/media/chrome-logo.41e84a0386af8500c429f7cc49cac78b.svg";
export { ForwardRef as ReactComponent };